import { createReducer } from '@reduxjs/toolkit'
import { Constraints } from 'interfaces/api/promoSettings.interfaces'
import { ValidationErrorsApi } from 'packages/api'
import { createBuilder } from 'packages/redux-toolkit'

import {
  createAllConstraints,
  getAllConstraints,
  removeConstraint,
  setConstraintsValidationErrors,
  updateConstraint,
} from './actions'

interface PromoConstraintsState {
  list: {
    loading: boolean
    items: Constraints
  }
  single: {
    loading: boolean
    item: string | null
  }
  validation: ValidationErrorsApi | null
}

const initialState: PromoConstraintsState = {
  list: {
    loading: false,
    items: {
      constraints: [],
    },
  },
  single: {
    loading: false,
    item: null,
  },
  validation: null,
}

export const promoConstraintsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllConstraints.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllConstraints.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllConstraints.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })

    .addCase(setConstraintsValidationErrors, (state, { payload }) => {
      state.validation = payload
    })

    .addCase([createAllConstraints.pending, removeConstraint.pending, updateConstraint.pending], (state) => {
      state.list.loading = true
    })
    .addCase([createAllConstraints.rejected, removeConstraint.rejected, updateConstraint.rejected], (state) => {
      state.list.loading = false
    })
    .addCase([createAllConstraints.fulfilled, removeConstraint.fulfilled, updateConstraint.fulfilled], (state) => {
      state.list.loading = false
    })
})
